{
  "version": 1,
  "default_set": "standard",
  "default_release": 0.5,
  "clay_abundance_ref_pct": 30,
  "sets": {
    "conservative": {
      "kaolinite": 0,
      "smectite": 0.03,
      "illite": 0.2,
      "vermiculite": 0.35,
      "chlorite": 0,
      "mixed_layer": 0.2,
      "oxides": 0,
      "quartz_other": 0
    },
    "standard": {
      "kaolinite": 0.01,
      "smectite": 0.08,
      "illite": 0.35,
      "vermiculite": 0.55,
      "chlorite": 0.01,
      "mixed_layer": 0.35,
      "oxides": 0,
      "quartz_other": 0
    }
  }
}
